/*
 * Returns an array acceptable for dropdown.
 * */

export const getOptions = ({ data, value, label }) => {
  let options = [];
  if (!data) {
    return [];
  }
  data.forEach((items) => {
    options.push({ value: items[`${value}`], label: items[`${label}`] });
  });
  return options;
};
